import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_GENERIC_SUSPENSION } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIdOlSospensioneState extends EntityState<IID_GENERIC_SUSPENSION, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_GENERIC_SUSPENSION })
@InterfaceDataStore(InterfaceName.GENERIC_SUSPENSION)
export class IIDgenericSuspensionStore extends EntityStore<IIdOlSospensioneState> {
  constructor() {
    super([]);
  }
}
